"use client";

import React, { createContext, useContext, useState } from "react";
import { useTourPageContext } from "../tour-page-context";

export type WeatherContextProps = {
    isCustomary: boolean;
    setIsCustomary: React.Dispatch<React.SetStateAction<boolean>>;
    isTemperature: boolean;
    setIsTemperature: React.Dispatch<React.SetStateAction<boolean>>;
};

const WeatherContext = createContext<WeatherContextProps>(null!);

export const useWeatherContext = () => useContext(WeatherContext);

export const WeatherContextProvider: React.FC<
    React.PropsWithChildren<unknown>
> = ({ children }) => {
    const { pageConfig } = useTourPageContext();

    const [isCustomary, setIsCustomary] = useState(
        pageConfig.defaultUSCustomary ?? true,
    );
    const [isTemperature, setIsTemperature] = useState(true);
    return (
        <WeatherContext.Provider
            value={{
                isCustomary,
                setIsCustomary,
                isTemperature,
                setIsTemperature,
            }}
        >
            {children}
        </WeatherContext.Provider>
    );
};
